import {
    REQUEST_LIQUIDATIONS_DASHBOARD,
    RECEIVE_LIQUIDATIONS_DASHBOARD,
    UPDATE_LIQUIDATIONS_DASHBOARD,
    ERROR_LIQUIDATIONS_DASHBOARD,
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"
import _isEmpty from "lodash/isEmpty"
import _get from "lodash/get";

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_LIQUIDATIONS_DASHBOARD:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_LIQUIDATIONS_DASHBOARD:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case UPDATE_LIQUIDATIONS_DASHBOARD:
            const data = state.data
            const ut = action.updateType
            if(!_isEmpty(data.results)){
                if(ut == "create-column"){
                    const payload = action.payload
                    if(typeof payload.cards == "undefined"){
                        payload.cards = []
                    }
                    data.results.push(payload)
                    data.results.sort((a,b) => b.priority - a.priority)
                }else if(ut == "update-column"){
                    const index = data.results.findIndex(col => col.id == action.id)
                    if(index > -1){
                        data.results[index] = {...data.results[index], ...action.payload}
                    }
                }else if(["delete-card", "update-card", "create-card"].includes(ut)){
                    for (let i = 0; i < data.results.length; i++) {
                        if(ut == "create-card"){
                            if(data.results[i].id == action.id){
                                data.results[i].cards.push(action.payload)
                                data.results[i].cards_count++
                            }
                        }else{
                            const cardIndex = _get(data.results[i], "cards", []).findIndex(c => c.id == action.id)
                            if(cardIndex > -1){
                                if(ut == "delete-card"){
                                    data.results[i].cards.splice(cardIndex, 1)
                                    data.results[i].cards_count--
                                }else if(ut == "update-card"){
                                    data.results[i].cards[cardIndex] = action.payload
                                }
                                break
                            }
                        }
                    }
                }else if(ut == "move-card"){
                    const {fromColumn, toColumn, toPosition} = action.payload
                    const columnFrom = data.results.find(column => column.id == fromColumn)
                    const columnTo = data.results.find(column => column.id == toColumn)
                    if(columnFrom && columnTo){
                        const index = _get(columnFrom, "cards", []).findIndex(c => c.id == action.id)
                        if(index > -1){
                            const [card] = columnFrom.cards.splice(index, 1)
                            columnFrom.cards_count--
                            columnTo.cards_count++
                            if(toPosition !== null){
                                columnTo.cards.splice(toPosition, 0, card)
                            }else{
                                columnTo.cards.push(card)
                            }
                        }
                    }
                }else if (['update-card-add-tag', 'update-card-remove-tag'].includes(ut)) {
                    for (let col = 0; col < data.results.length; col++) {
                        const cardIndex = _get(data.results[col], "cards", []).findIndex(c => c.id == action.id)
                        if(cardIndex > -1) {
                            if (ut == 'update-card-remove-tag') {
                                const tagIndex = _get(data.results[col].cards[cardIndex], "tags", []).findIndex(t => t.id == action.payload.tag)
                                if (tagIndex > -1) {
                                    data.results[col].cards[cardIndex].tags.splice(tagIndex, 1)
                                }
                            } else if (ut == 'update-card-add-tag') {
                                data.results[col].cards[cardIndex].tags.push(action.payload.tag)
                            }
                        }
                    }
                }else if(ut == "load-more"){
                    const {page, total_pages, cards} = action.payload
                    const index = data.results.findIndex(col => col.id == action.payload.id)
                    if(index > -1){
                        data.results[index].page = page
                        data.results[index].total_pages = total_pages
                        data.results[index].cards = [...data.results[index].cards, ...cards]
                    }
                }
            }else if(ut == "create-column"){
                data.results = []
                const payload = action.payload
                if(typeof payload.cards == "undefined"){
                    payload.cards = []
                }
                data.results.push(payload)
                data.results.sort((a,b) => b.priority - a.priority)
            }
            return {
                ...state,
                isFetching: false,
                data,
                errors: action.errors
            }
        case ERROR_LIQUIDATIONS_DASHBOARD:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}